module.exports = __webpack_public_path__ + "img/part-5-tittle-add.2b0cf59d.png";